'use client'

import { useEffect } from "react";

export default function ConsentBarMargin() {
    useEffect(() => {
        function updateMargin() {
            const consentBar = document.getElementById("JOISH987_bar");
            if (consentBar) {
                document.body.style.marginBottom = `${consentBar.offsetHeight}px`;
            } else {
                document.body.style.marginBottom = "";
            }
        }

        const bodyObserver = new MutationObserver(() => {
            updateMargin();
        });
        bodyObserver.observe(document.body, { childList: true, subtree: true });

        window.addEventListener('resize', updateMargin);

        updateMargin();

        return () => {
            bodyObserver.disconnect();
            window.removeEventListener('resize', updateMargin);
            document.body.style.marginBottom = "";
        };
    }, []);
    return null;
}